<template>
  <!-- 模块标题 -->
  <div class="module-title">
    <h2>{{title}}</h2>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped>
  .module-title {
    width: 100%;
    background: url(../../assets/img/detail/title-bg.png) center;
    background-size: auto 100%;
  }

  .module-title h2{
    height: 37px;
    text-align: center;
    font-size: 1rem;
    line-height: 37px;
  }
</style>



// WEBPACK FOOTER //
// src/components/detail/module-title.vue